export default __webpack_public_path__ + "static/media/03.10de69c8.jpg";